// extracted by mini-css-extract-plugin
module.exports = {"comment":"_7733","hd":"_821","title":"_193","more":"_17122","text":"_1850","arrow":"_16342","tags":"_10598","item":"_4067"};